import {IntermediatePart} from "../../intermediatePart";
import isEqual from "lodash/isEqual";
import {METADATA} from "../../constants";

export default class Attachment extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = "attachment";
    this.partName = "Attachment";
    this.hasAdditionalParts = true;
  }

  load(dbFeature) {
    if (!dbFeature.metaData["Side"] && dbFeature.sharedFeatureName.includes("ountertop")) {
      dbFeature.metaData["Side"] = [METADATA.LeftSide];
    }
    return super.load(dbFeature);
  }

  checkIfFeaturePartIsMatching() {
    this.activeFeatureParts = this.setActiveFeatureParts();
  }

  setActiveFeatureParts() {
    const layout = this.getParent().layout;
    const activeFeatures = layout.getActiveFeatures(true, true);
    let matchingFeatures = [];
    const currentConditions = this.getArrayOfConditions();
    const selectFrom = this.features.filter(attFeature => attFeature.matchesMetaForArrayOfConditions(currentConditions));
    activeFeatures.forEach(cartItem => {
      if (!cartItem.cartFeature || cartItem.featureGroup.disabled || !cartItem.cartFeature.metaData["MatchingFeature"]
        || (cartItem.partId === this.partId)) {
        return
      }
      selectFrom.forEach(attFeature => {
        if (attFeature.metaData["MatchingFeature"] && attFeature.metaData["MatchingFeature"].includes("Splitwall")) {
          const splitWall = layout.parts.Walls.splitWall;
          if (splitWall && !splitWall.disabled && splitWall.activeFeature && splitWall.activeFeature.layer.src
            && !matchingFeatures.some(alreadyAddedFeature => alreadyAddedFeature.metaData["MatchingFeature"]
              && alreadyAddedFeature.metaData["MatchingFeature"].includes("Splitwall"))) {
            matchingFeatures.push(attFeature);
          }
        } else if (isEqual(attFeature.metaData["MatchingFeature"], cartItem.cartFeature.metaData["MatchingFeature"])
          && isEqual(attFeature.metaData["Side"], cartItem.cartFeature.metaData["Side"])
          && !matchingFeatures.some(alreadyAddedFeature => {
            return isEqual(attFeature.metaData["MatchingFeature"], alreadyAddedFeature.metaData["MatchingFeature"])
              && isEqual(attFeature.metaData["Side"], alreadyAddedFeature.metaData["Side"])
          })) {
          matchingFeatures.push(attFeature)
        }
      })
    })
    return matchingFeatures;
  }

}
